import Vuex from "vuex";
import { GET_LOADING } from "./getter-types";
import { SET_LOADING } from "./mutation-types";
import { GET_PAYMENT_METHOD} from "./getter-types";
import { SET_PAYMENT_METHOD } from "./mutation-types";
import {
  searchState,
  searchMutations,
  searchGetters,
  searchActions
} from "./search/index";
import {
  stepperState,
  stepperMutations,
  stepperGetters,
  stepperActions
} from "./stepper/index";
import {
  bookingState,
  bookingGetters,
  bookingMutations,
  bookingActions
} from "./booking/index";
import {
  destiniesState,
  destiniesMutations,
  destiniesActions,
  destiniesGetters
} from "./destinies/index";
import {
  giftState,
  giftMutations,
  giftActions,
  giftGetters
} from "./gifts/index";
import {
  snackbarState,
  snackbarMutations,
  snackbarGetters
} from "./snackbar/index";
import {
  passengersState,
  passengersMutations,
  passengersGetters,
  passengersActions
} from "./reserve-area/index";
import {
  nightsState,
  nightsMutations,
  nightsGetters,
  nightsActions
} from "./nights/index";
import {
  uiState,
  uiMutations
} from './ui/index';
window.Vue = require("vue");

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loading: false,
    ...searchState,
    ...stepperState,
    ...bookingState,
    ...giftState,
    ...destiniesState,
    ...snackbarState,
    ...passengersState,
    ...uiState,
    ...nightsState,
    paymentMethod: 'redsys'
  },
  getters: {
    ...searchGetters,
    ...stepperGetters,
    ...bookingGetters,
    ...destiniesGetters,
    ...giftGetters,
    ...passengersGetters,
    ...snackbarGetters,
    ...nightsGetters,
    [GET_LOADING](state) {
      return state.loading;
    },
    [GET_PAYMENT_METHOD](state){
      return state.paymentMethod;
    }
  },
  mutations: {
    ...searchMutations,
    ...stepperMutations,
    ...bookingMutations,
    ...destiniesMutations,
    ...giftMutations,
    ...snackbarMutations,
    ...passengersMutations,
    ...uiMutations,
    ...nightsMutations,
    [SET_LOADING](state, payload) {
      state.loading = payload;
    },
    [SET_PAYMENT_METHOD](state, payload){
      state.paymentMethod = payload;
    }
  },
  actions: {
    ...searchActions,
    ...stepperActions,
    ...bookingActions,
    ...destiniesActions,
    ...giftActions,
    ...passengersActions,
    ...nightsActions,
  }
});

export default store;
